import { render, staticRenderFns } from "./AyinNamehDetails.vue?vue&type=template&id=7ba41dbc"
import script from "./AyinNamehDetails.vue?vue&type=script&lang=js"
export * from "./AyinNamehDetails.vue?vue&type=script&lang=js"
import style0 from "./AyinNamehDetails.vue?vue&type=style&index=0&id=7ba41dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports